import PropTypes from "prop-types";
import { useState } from "react";
import { FormattedMessage } from "react-intl";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Avatar, Badge, Box, Button, Grid, Tooltip } from "@mui/material";
import { makeStyles } from "@mui/styles";
import Banner from "../../../../../assets/img/bg/UserDetails.png";
import Profile from "../../../../../assets/img/default-avatar.png";
import AddressRow from "../../../../UserDetails/AccountSettingsModal/BannerSection/AddressRow";
import BioDescription from "../../../../UserDetails/AccountSettingsModal/BannerSection/BioDescription";
import DirectMessageButton from "../../../../UserDetails/AccountSettingsModal/BannerSection/DirectMessageButton";
import EmploymentRow from "../../../../UserDetails/AccountSettingsModal/BannerSection/EmploymentRow";
import NameRow from "../../../../UserDetails/AccountSettingsModal/BannerSection/NameRow";
import AvatarUpload from "../AvatarUpload";

const useStyles = makeStyles(theme => ({
  userAvatar: {
    width: 150,
    height: 150,
    borderWidth: 7,
    borderColor: "#fff",
    borderStyle: "solid",
  },
  badgedAvatar: {
    position: "absolute",
    left: 30,
    top: 40,
  },
  btnContainer: {
    marginTop: 40,
  },
  viewAs: {
    position: "absolute",
    right: 0,
    marginRight: 18,
    top: 0,
    marginTop: 185,
    [theme.breakpoints.down("sm")]: {
      marginRight: 16,
    },
  },
  mainContent: {
    marginTop: 20,
    paddingLeft: 200,
    [theme.breakpoints.down("sm")]: {
      padding: "12px 18px",
      marginTop: 40,
    },
  },
  bioDesc: {
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
}));

const BannerSection = ({
  accountSettings,
  editMode,
  onDirectMessageRequest,
  setAccountSettings,
  setIsViewedAs,
}) => {
  const classes = useStyles();

  const [avatarProfile, setAvatarProfile] = useState(null);
  const [openUpload, setOpenUpload] = useState(false);

  const {
    avatarUrl,
  } = accountSettings || {};

  return accountSettings && (
    <>
      <Box flex={1} style={{ position: "relative" }}>
        <Box flex={1} style={{ height: 130, background: `url(${Banner})`, position: "relative" }}>
          <Badge
            overlap="circle"
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            className={classes.badgedAvatar}
          >
            <Avatar
              className={classes.userAvatar}
              src={avatarProfile || avatarUrl}
            />
          </Badge>
          <Box
            component="div"
            sx={{
              display: "flex",
              flexdirection: "row",
              height: "100%",
              justifyContent: "flex-end",
              alignItems: "flex-end",
            }}
          >
            {editMode && (
              <DirectMessageButton onClick={onDirectMessageRequest} />
            )}
          </Box>
        </Box>
        <Box flex={1} style={{ minHeight: 100 }}>
          <Grid container alignItems="center" className={classes.mainContent}>
            {false /* TODO */ && (
              <div className={classes.viewAs}>
                <Tooltip
                  arrow
                  placement="left"
                  title={<FormattedMessage id="tooltip.preview" />}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.button}
                    size="small"
                    onClick={() => setIsViewedAs(true)}
                  >
                    <VisibilityIcon />
                  </Button>
                </Tooltip>
              </div>
            )}
            <Grid item sm={12} md={6} style={{ flexGrow: 1 }}>
              <NameRow
                accountSettings={accountSettings}
                setAccountSettings={setAccountSettings}
              />
              <EmploymentRow
                accountSettings={accountSettings}
                setAccountSettings={setAccountSettings}
              />
              <AddressRow
                accountSettings={accountSettings}
                setAccountSettings={setAccountSettings}
              />
              <BioDescription
                accountSettings={accountSettings}
                setAccountSettings={setAccountSettings}
              />
            </Grid>
          </Grid>
        </Box>
      </Box>
      {openUpload && (
        <AvatarUpload
          setOpenUpload={setOpenUpload}
          setAvatarProfile={setAvatarProfile}
          defaultAvatar={Profile}
          currentAvatar={avatarUrl}
        />
      )}
    </>
  );
};

BannerSection.propTypes = {
  accountSettings: PropTypes.shape({}),
  setAccountSettings: PropTypes.func.isRequired,
  setIsViewedAs: PropTypes.func.isRequired,
};

export default BannerSection;
